import React from 'react';

const SwingResultsTable = ({ stocks, onTradeClick, onChartClick, type = 'call' }) => {
  if (!stocks || stocks.length === 0) {
    return (
      <div className="text-center py-6 text-gray-500">
        <p className="text-sm">No stocks found in this category.</p>
      </div>
    );
  }

  const formatNumber = (value, decimals = 2) => {
    if (value === null || value === undefined) return '-';
    return Number(value).toFixed(decimals);
  };

  const formatPercent = (value) => {
    if (value === null || value === undefined) return '-';
    const num = Number(value);
    const color = num >= 0 ? 'text-green-600' : 'text-red-600';
    const arrow = num >= 0 ? '▲' : '▼';
    return (
      <span className={color}>
        {arrow} {Math.abs(num).toFixed(2)}%
      </span>
    );
  };

  // Determine button color based on type
  const getButtonColor = () => {
    switch(type) {
      case 'call':
        return 'bg-green-600 hover:bg-green-700';
      case 'put':
        return 'bg-red-600 hover:bg-red-700';
      case 'near_call':
        return 'bg-yellow-600 hover:bg-yellow-700';
      case 'near_put':
        return 'bg-orange-600 hover:bg-orange-700';
      default:
        return 'bg-blue-600 hover:bg-blue-700';
    }
  };

  return (
    <div className="overflow-x-auto">
      <table className="min-w-full bg-white border border-gray-200">
        <thead className="bg-gray-100">
          <tr>
            <th className="px-4 py-2 text-left text-xs font-medium text-gray-700 uppercase tracking-wider border-b">
              Symbol
            </th>
            <th className="px-4 py-2 text-left text-xs font-medium text-gray-700 uppercase tracking-wider border-b">
              Action
            </th>
            <th className="px-4 py-2 text-right text-xs font-medium text-gray-700 uppercase tracking-wider border-b">
              Price
            </th>
            <th className="px-4 py-2 text-right text-xs font-medium text-gray-700 uppercase tracking-wider border-b">
              Hourly RSI
            </th>
            <th className="px-4 py-2 text-right text-xs font-medium text-gray-700 uppercase tracking-wider border-b">
              Daily RSI
            </th>
            <th className="px-4 py-2 text-right text-xs font-medium text-gray-700 uppercase tracking-wider border-b">
              Weekly RSI
            </th>
            <th className="px-4 py-2 text-right text-xs font-medium text-gray-700 uppercase tracking-wider border-b">
              Momentum
            </th>
            <th className="px-4 py-2 text-right text-xs font-medium text-gray-700 uppercase tracking-wider border-b">
              Vol Ratio
            </th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-200">
          {stocks.map((stock, index) => (
            <tr
              key={`${stock.symbol}-${index}`}
              className="hover:bg-gray-50 transition-colors"
            >
              <td className="px-4 py-3 whitespace-nowrap">
                <button
                  onClick={() => onChartClick && onChartClick(stock.symbol)}
                  className="text-blue-600 hover:text-blue-800 font-semibold hover:underline cursor-pointer"
                  title="Click to view chart"
                >
                  {stock.symbol}
                </button>
              </td>
              <td className="px-4 py-3 whitespace-nowrap">
                <button
                  onClick={() => onTradeClick(stock.symbol)}
                  className={`px-3 py-1.5 text-white rounded-md transition-colors font-medium text-sm ${getButtonColor()}`}
                >
                  Trade
                </button>
              </td>
              <td className="px-4 py-3 whitespace-nowrap text-right text-gray-900">
                ₹{formatNumber(stock.current_price)}
              </td>
              <td className="px-4 py-3 whitespace-nowrap text-right text-gray-900">
                {formatNumber(stock.hourly_rsi, 1)}
              </td>
              <td className="px-4 py-3 whitespace-nowrap text-right text-gray-900">
                {formatNumber(stock.daily_rsi, 1)}
              </td>
              <td className="px-4 py-3 whitespace-nowrap text-right text-gray-900">
                {formatNumber(stock.weekly_rsi, 1)}
              </td>
              <td className="px-4 py-3 whitespace-nowrap text-right">
                {formatPercent(stock.price_momentum)}
              </td>
              <td className="px-4 py-3 whitespace-nowrap text-right text-gray-900">
                {formatNumber(stock.volume_ratio)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default SwingResultsTable;

